<template>
  <app-header></app-header>
  <router-view></router-view>
</template>

<script>
import AppHeader from './app-header.vue'

export default {
  name: 'App',
  components: { AppHeader }
}
</script>

<style lang="scss">
/* open-sans-regular - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/open-sans-v13-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Open Sans'), local('OpenSans'),
       url('./assets/fonts/open-sans-v13-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/open-sans-v13-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/open-sans-v13-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/open-sans-v13-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/open-sans-v13-latin-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-italic - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 400;
    src: url('./assets/fonts/open-sans-v13-latin-italic.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Italic'), local('OpenSans-Italic'),
        url('./assets/fonts/open-sans-v13-latin-italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/open-sans-v13-latin-italic.woff2') format('woff2'), /* Super Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-italic.woff') format('woff'), /* Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-italic.ttf') format('truetype'), /* Safari, Android, iOS */
        url('./assets/fonts/open-sans-v13-latin-italic.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-700 - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    src: url('./assets/fonts/open-sans-v13-latin-700.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Bold'), local('OpenSans-Bold'),
        url('./assets/fonts/open-sans-v13-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/open-sans-v13-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-700.woff') format('woff'), /* Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
        url('./assets/fonts/open-sans-v13-latin-700.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-700italic - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 700;
    src: url('./assets/fonts/open-sans-v13-latin-700italic.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Bold Italic'), local('OpenSans-BoldItalic'),
        url('./assets/fonts/open-sans-v13-latin-700italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/open-sans-v13-latin-700italic.woff2') format('woff2'), /* Super Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-700italic.woff') format('woff'), /* Modern Browsers */
        url('./assets/fonts/open-sans-v13-latin-700italic.ttf') format('truetype'), /* Safari, Android, iOS */
        url('./assets/fonts/open-sans-v13-latin-700italic.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  #app {
    font-family: 'Open Sans';
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: grid;
    grid-template-rows: max-content max-content auto max-content;
    height: 100vh;

    h1, h2, h3, h4 {
      margin: 0 0 10px 0;
    }

    h1, h2, h3, h4, h5 {
      color: #0067b1;
      font-weight: bold;
    }

    p {
      text-align: justify;
    }
    
    strong {
      color: #0067b1;
    }

    .section {
      width: 100%;
      overflow: hidden;
    }

    .section_odd {
      background-color: #f1f6f1;
      .description_panel {
        border: solid 1px #fff;
        background-color: #fff;
      }
    }

    .section_even {
      background-color: #fff;
      .description_panel {
        border: solid 1px #f1f6f1;
        background-color: #f1f6f1;
      }
    }

    .breadcrumb {
      padding: 8px 15px;
      margin-bottom: 20px;
      list-style: none;
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    .loading{
      text-align: center;
      background: #ddd;
      padding: 150px 0;

      .lds-dual-ring {
        display: inline-block;
        width: 120px;
        height: 120px;
      }
      .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 92px;
        height: 92px;
        margin: 1px;
        border-radius: 50%;
        border: 10px solid #fff;
        border-color: #9999ff transparent #fff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
      }
      @keyframes lds-dual-ring {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  #app {
    height: 100dvh;
  }

  @media print{
    #app {
      font-size: 12px;

      h1, h2, h3, h4 {
        margin-bottom: 3px;
      }

      .section {
        padding: 5px 0;
      }

      .breadcrumb {
        padding: 2px 15px;
        margin-bottom: 0;
      }
    }
  }



</style>
